export const TOKEN = "6bc2249f37e22503fa485ca81f62a127";
export const AUTH = "Еб@ть";

export const apiUrl = "https://ebat-ex.ebat.me/api";

export const url = "https://ebat-ex.ebat.me/api/v1/gather_club";
